import styled from "@emotion/styled";
import { Flex, mediaQueries, Theme, Typography } from "@ugc-ui/lego";
import { mixins } from "@src/styles/mixins.styled";

export const ShowCampaignWrapper = styled.div`
  margin: 0 auto;
  max-width: 904px;
`;

export const ShowCampaignContainer = styled(Flex)<{ theme: Theme }>`
  overflow: auto;
  height: 670px;
  padding-right: 10px;
  max-width: 528px;
  ${({ theme }) => mixins.scroll(theme)}
  ${mediaQueries.lg} {
    height: auto;
  }
`;

export const DescriptionText = styled(Typography)`
  word-break: break-all;
`;

export const VideoCampaignButton = styled.div<{ theme: Theme }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  background-color: ${({ theme }) => theme.background["01"]};
  padding: 7px 12px;
  border-radius: 12px;
  cursor: pointer;
  transition: 0.5s all;
  user-select: none;
  &:hover {
    background-color: rgba(255, 255, 255, 0.02);
  }
`;

export const Divider = styled.div<{ theme: Theme }>`
  height: 1px;
  display: list-item;
  background-color: ${({ theme }) => theme.gray.a05};
  margin: 24px 0;
`;

export const TypographyDate = styled(Typography)`
  ${mediaQueries.lg} {
    max-width: 80px;
  }
`;

export const StatisticChartContainer = styled(Flex)`
  flex-direction: column;
  gap: 24px;

  padding-top: 16px;

  width: 100%;

  border: 1px solid rgba(48, 48, 54, 1);
  border-radius: 12px;
`;

export const StatisticChartTitle = styled(Flex)`
  padding: 0 12px;
`;
